<script lang="ts">
	import Input from "@components/form/Input.svelte";
	import Labelled from "@components/form/Labelled.svelte";
	import type { ComponentProps, Snippet } from "svelte";
	import type { ClassValue, HTMLLabelAttributes } from "svelte/elements";

	const {
		wrapperClass,
		label,
		children,
		...rest
	}: ComponentProps<typeof Input> & { wrapperClass?: ClassValue; children: Snippet; label?: HTMLLabelAttributes } =
		$props();

	const id = $derived(`${rest.id ?? rest.name ?? ""}-${crypto.randomUUID()}`);
	const isRadioOrCheckbox = $derived(["checkbox", "radio"].includes(String(rest.type)));
</script>

<Labelled {wrapperClass} required={rest.required} label={{ ...label, for: id }} horizontal={isRadioOrCheckbox}>
	{@render children()}
	{#snippet content()}
		<Input class={[isRadioOrCheckbox ? "shrink-0" : "flex-1", rest.class]} {...rest} {id} />
	{/snippet}
</Labelled>
